export const MapBox_API_TOKEN = 'pk.eyJ1Ijoic2tpcGlmeSIsImEiOiJjbGRsdmF4OXMwM2UxM3dudzJmZnQzNmpkIn0.GsWX-1VgRIG0sCF8yzl_4w'

export const Google_reCaptcha_Site_Key = '6LcZNCMpAAAAANmyH8UXo28q9XFiXWzzY1gBUMGs';
export const Google_reCaptcha_Secret_Key = '6LcZNCMpAAAAAAmIeWR4sGYAWtI1yeQhuHYY7Qb4';

export const GOOGLE_MAP_KEY = 'AIzaSyDRKoA3F7kBn_iSoivCwwvXunFTMFHE2R8'; // connect@skipify.ai on console.cloud.google

// You can find more credentials in .env file
